<template>
    <div class="content-block"
         :class="[color, {fadeInUp: customAnimation && isVisible},{ hide: customAnimation}]"
         v-observe-visibility="{
                callback: visibilityChanged,
                throttle: 300,
                intersection: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: 0
                }
           }">
        <wp-image v-if="display_pattern"
                  :image="image_pattern"
                  size-sd="rectangle-sd"
                  class="pattern pattern-top"
        ></wp-image>
        <div class="block">
            <section-heading v-if="section_heading" :text="section_heading" :color="color" />
            <h2 v-if="title" class="h1 title">
                {{ title }}
            </h2>
            <a v-if="showAddress" :href="googleMaps" class="address">
                {{ address.street }}, {{ address.city }}, {{ address.state }} {{ address.zip }}
            </a>
            <div v-if="body" class="description" v-html="body"></div>
            <button-link v-if="button && button.text" v-bind="button" />
        </div>
        <wp-image v-if="display_pattern"
                  :image="image_pattern"
                  size-sd="rectangle-sd"
                  class="pattern pattern-bottom"
        ></wp-image>
    </div>
</template>

<script>
    import {EventBus} from '../../utils/EventBus'
    import ButtonLink from './ButtonLink'
    import SectionHeading from './SectionHeading'

    export default {
        name: "ContentBlock",
        components: { SectionHeading, ButtonLink },
        props: {
            customAnimation: {
                type: Boolean,
                default: false
            },
            display_pattern: {
                type: Boolean,
                default: false
            },
            image_pattern: {
                type: Boolean | Object,
                default: false
            },
            section_heading: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            body: {
                type: String,
                default: ''
            },
            button: Object,
            color: {
                type: String,
                default: 'blue'
            },
            showAddress: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isVisible: false,
                address: wp.settings.address,
                googleMaps: wp.settings.google_maps_address_link
            }
        },
        methods: {
            visibilityChanged(isVisible) {
                if (EventBus.pageLoaded && !this.isVisible) this.isVisible = isVisible
            },
        },
    }
</script>

<style lang="scss" scoped>

    .hide {
        opacity: 0;
    }

    // Fade In Up
    .fadeInUp {
        animation-duration: 1s;
        animation-fill-mode: both;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        -webkit-animation-name: fadeInUp;
        animation-name: fadeInUp;
    }
    @-webkit-keyframes fadeInUp {
        from {
            transform: translate3d(0,40px,0)
        }
        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }
    @keyframes fadeInUp {
        from {
            transform: translate3d(0,40px,0)
        }

        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }

    .content-block {
        padding: 0 30px;

        @media (min-width: $bp-mobile) {
            padding: 0 60px;
        }
    }

    .block {
        padding: 50px 0;

        @media (min-width: $bp-small) {
            padding: 75px 0;
        }
    }

    .description {
        color: #000;
        margin: 25px 0;
    }

    .title {
        margin-top: 25px;
        margin-bottom: 30px;
    }

    .white {
        .description {
            color: $white;
        }
    }

    .button {
        margin-top: 50px;
    }

    .pattern {
        width: 100%;
    }

</style>

<style lang="scss">

    .content-block {

        ul {
            padding-left: 0;
            display: inline-block;
            list-style: none;

            li:not(.list-item) {
                position: relative;
                padding-left: 30px;
                margin-bottom: 2.5px;

                &:not(.list-item):before {
                    content:"";
                    height: 14px;
                    width: 14px;
                    display: block;
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    position: absolute;
                    left: 1px;
                    top: 5px;
                }
            }

            &.list {
                margin: 0;
            }
        }

        &.blue {
            li:not(.list-item):before {
                background-image: url("data:image/svg+xml,%3Csvg width='11px' height='10px' viewBox='0 0 11 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Desktop-Design' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='R2-Amenities-Tamarac_Village-Desktop_Design' transform='translate(-122.000000, -999.000000)' fill='%2310284A'%3E%3Cg id='Group-8-Copy-5' transform='translate(122.000000, 999.000000)'%3E%3Cpolygon id='Fill-1' points='2.24036513 6 6 8 1 7.16627772'%3E%3C/polygon%3E%3Cpolygon id='Fill-2' points='7 3.85856386 3 6 6.39649909 2'%3E%3C/polygon%3E%3Cpolygon id='Fill-3' points='7 4 6.78739532 8 3 5.8362324'%3E%3C/polygon%3E%3Cpolygon id='Fill-4' points='7.22943478 5 9 10 7 9.61703482'%3E%3C/polygon%3E%3Cpolygon id='Fill-5' points='7 3.00239684 9.33321592 9 11 9 7.00015096 3'%3E%3C/polygon%3E%3Cpolygon id='Fill-6' points='5.31026298 0 2 6 2.00208216 5.99891053 6 1.25015071'%3E%3C/polygon%3E%3Cpolygon id='Fill-7' points='0 9 7 9 6.99801862 8.99895423 0.729236382 8'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
            }
        }

        &.white {
            li:not(.list-item):before {
                background-image: url("data:image/svg+xml,%0A%3Csvg width='11px' height='10px' viewBox='0 0 11 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Desktop-Design' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='R2-Amenities-Tamarac_Village-Desktop_Design' transform='translate(-814.000000, -1949.000000)' fill='%23FFFFFF'%3E%3Cg id='Group-8' transform='translate(814.000000, 1949.000000)'%3E%3Cpolygon id='Fill-1' points='2.24036513 6 6 8 1 7.16627772'%3E%3C/polygon%3E%3Cpolygon id='Fill-2' points='7 3.85856386 3 6 6.39649909 2'%3E%3C/polygon%3E%3Cpolygon id='Fill-3' points='7 4 6.78739532 8 3 5.8362324'%3E%3C/polygon%3E%3Cpolygon id='Fill-4' points='7.22943478 5 9 10 7 9.61703482'%3E%3C/polygon%3E%3Cpolygon id='Fill-5' points='7 3.00239684 9.33321592 9 11 9 7.00015096 3'%3E%3C/polygon%3E%3Cpolygon id='Fill-6' points='5.31026298 0 2 6 2.00208216 5.99891053 6 1.25015071'%3E%3C/polygon%3E%3Cpolygon id='Fill-7' points='0 9 7 9 6.99801862 8.99895423 0.729236382 8'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
            }
        }

        a {
            text-decoration: none;
            font-weight: bold;
            color: #000;
            &:hover {
                cursor: pointer;
                color: $theme-orange;
            }
        }
    }


</style>